import React, { useState, useEffect } from "react";
import styles from "./index.module.css";
import serviceText from "assets/files/service.txt";


export default function Service() {
    const [text, setText] = useState("");

    useEffect(() => {
        fetch(serviceText)
            .then((res) => res.text())
            .then((data) => setText(data));
    }, []);

    return (
        <div className={styles.wrapper}>
            <pre className={styles.textBox}>{text}</pre>
        </div>
    );
}